import startCase from 'lodash/startCase';

export function publicCase(value) {
  return startCase(value.toLowerCase());
}

export function parseJSON(json, replacer) {
  let object;
  
  try {
    object = JSON.parse(json, replacer);
  } catch (e) {
    object = null;
  }
  
  return object;
}
